/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { useDispatch, useSelector } from 'react-redux';

import { ImgStyled } from '../../../../components/common/Block/Img';
import LinkBlock from '../../../../components/common/LinkBlock/LinkBlock';
import { ELogBusinessEventName, ELogBusinessEventType, logBusinessEvent } from '../../../../modules/logging';
import { makeSelectGuardComponents } from '../../../../modules/role';
import { HistoryOrderActionFilesIcon } from '../../../../types/orderTypes';
import { getPageOrderIdFileUrl } from '../../../PageOrderId';
import { ITableOrder, ITableOrderFile } from '../../types';

const TableOrderCellFile = ({ file, row }: { file: ITableOrderFile; row: ITableOrder; }) => {

    const dispatch = useDispatch();
    const componentsFeature = useSelector(makeSelectGuardComponents());

    const onClick = () => {
        dispatch(logBusinessEvent({
            eventName: ELogBusinessEventName.USER_REPORT_DOWNLOAD,
            type: ELogBusinessEventType.common,
        }));

        const url = getPageOrderIdFileUrl(componentsFeature, row.historyId, file.id?.toString());
        window.open(url, '_self');
    };

    return (
        <LinkBlock
            isExternalUrl
            url={getPageOrderIdFileUrl(componentsFeature, row.historyId, file.id?.toString())}
            onClick={onClick}
        >
            <ImgStyled
                className="medium"
                src={HistoryOrderActionFilesIcon[file.fileType || 'DEFAULT']}
                width="32px"
            />
        </LinkBlock>
    );
};

export default TableOrderCellFile;
